module.exports = __webpack_public_path__ + "static/media/BTS 3 Discs - Gradient.f1108233.png";